function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import EventEmitter from './event-emitter.js';
/**
 * A Web Audio buffer player emulating the behavior of an HTML5 Audio element.
 */

var WebAudioPlayer = /*#__PURE__*/function (_EventEmitter) {
  _inherits(WebAudioPlayer, _EventEmitter);

  var _super = _createSuper(WebAudioPlayer);

  function WebAudioPlayer() {
    var _this;

    var audioContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new AudioContext();

    _classCallCheck(this, WebAudioPlayer);

    _this = _super.call(this);
    _this.bufferNode = null;
    _this.autoplay = false;
    _this.playStartTime = 0;
    _this.playedDuration = 0;
    _this._muted = false;
    _this._playbackRate = 1;
    _this.buffer = null;
    _this.currentSrc = '';
    _this.paused = true;
    _this.crossOrigin = null;
    _this.seeking = false;
    /** Subscribe to an event. Returns an unsubscribe function. */

    _this.addEventListener = _this.on;
    /** Unsubscribe from an event */

    _this.removeEventListener = _this.un;
    _this.audioContext = audioContext;
    _this.gainNode = _this.audioContext.createGain();

    _this.gainNode.connect(_this.audioContext.destination);

    return _this;
  }

  _createClass(WebAudioPlayer, [{
    key: "load",
    value: function load() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "src",
    get: function get() {
      return this.currentSrc;
    },
    set: function set(value) {
      var _this2 = this;

      this.currentSrc = value;

      if (!value) {
        this.buffer = null;
        this.emit('emptied');
        return;
      }

      fetch(value).then(function (response) {
        if (response.status >= 400) {
          throw new Error("Failed to fetch ".concat(value, ": ").concat(response.status, " (").concat(response.statusText, ")"));
        }

        return response.arrayBuffer();
      }).then(function (arrayBuffer) {
        if (_this2.currentSrc !== value) return null;
        return _this2.audioContext.decodeAudioData(arrayBuffer);
      }).then(function (audioBuffer) {
        if (_this2.currentSrc !== value) return;
        _this2.buffer = audioBuffer;

        _this2.emit('loadedmetadata');

        _this2.emit('canplay');

        if (_this2.autoplay) _this2.play();
      });
    }
  }, {
    key: "_play",
    value: function _play() {
      var _this3 = this;

      var _a;

      if (!this.paused) return;
      this.paused = false;
      (_a = this.bufferNode) === null || _a === void 0 ? void 0 : _a.disconnect();
      this.bufferNode = this.audioContext.createBufferSource();
      this.bufferNode.buffer = this.buffer;
      this.bufferNode.playbackRate.value = this._playbackRate;
      this.bufferNode.connect(this.gainNode);
      var currentPos = this.playedDuration * this._playbackRate;

      if (currentPos >= this.duration) {
        currentPos = 0;
        this.playedDuration = 0;
      }

      this.bufferNode.start(this.audioContext.currentTime, currentPos);
      this.playStartTime = this.audioContext.currentTime;

      this.bufferNode.onended = function () {
        if (_this3.currentTime >= _this3.duration) {
          _this3.pause();

          _this3.emit('ended');
        }
      };
    }
  }, {
    key: "_pause",
    value: function _pause() {
      var _a;

      this.paused = true;
      (_a = this.bufferNode) === null || _a === void 0 ? void 0 : _a.stop();
      this.playedDuration += this.audioContext.currentTime - this.playStartTime;
    }
  }, {
    key: "play",
    value: function play() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.paused) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this._play();

                this.emit('play');

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.paused) return;

      this._pause();

      this.emit('pause');
    }
  }, {
    key: "stopAt",
    value: function stopAt(timeSeconds) {
      var _this4 = this;

      var _a, _b;

      var delay = timeSeconds - this.currentTime;
      (_a = this.bufferNode) === null || _a === void 0 ? void 0 : _a.stop(this.audioContext.currentTime + delay);
      (_b = this.bufferNode) === null || _b === void 0 ? void 0 : _b.addEventListener('ended', function () {
        _this4.bufferNode = null;

        _this4.pause();
      }, {
        once: true
      });
    }
  }, {
    key: "setSinkId",
    value: function setSinkId(deviceId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var ac;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ac = this.audioContext;
                return _context3.abrupt("return", ac.setSinkId(deviceId));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this._playbackRate;
    },
    set: function set(value) {
      this._playbackRate = value;

      if (this.bufferNode) {
        this.bufferNode.playbackRate.value = value;
      }
    }
  }, {
    key: "currentTime",
    get: function get() {
      var time = this.paused ? this.playedDuration : this.playedDuration + (this.audioContext.currentTime - this.playStartTime);
      return time * this._playbackRate;
    },
    set: function set(value) {
      this.emit('seeking');
      var wasPlaying = !this.paused;
      wasPlaying && this._pause();
      this.playedDuration = value / this._playbackRate;
      wasPlaying && this._play();
      this.emit('timeupdate');
    }
  }, {
    key: "duration",
    get: function get() {
      var _a;

      return ((_a = this.buffer) === null || _a === void 0 ? void 0 : _a.duration) || 0;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.gainNode.gain.value;
    },
    set: function set(value) {
      this.gainNode.gain.value = value;
      this.emit('volumechange');
    }
  }, {
    key: "muted",
    get: function get() {
      return this._muted;
    },
    set: function set(value) {
      if (this._muted === value) return;
      this._muted = value;

      if (this._muted) {
        this.gainNode.disconnect();
      } else {
        this.gainNode.connect(this.audioContext.destination);
      }
    }
  }, {
    key: "canPlayType",
    value: function canPlayType(mimeType) {
      return /^(audio|video)\//.test(mimeType);
    }
    /** Get the GainNode used to play the audio. Can be used to attach filters. */

  }, {
    key: "getGainNode",
    value: function getGainNode() {
      return this.gainNode;
    }
    /** Get decoded audio */

  }, {
    key: "getChannelData",
    value: function getChannelData() {
      var channels = [];
      if (!this.buffer) return channels;
      var numChannels = this.buffer.numberOfChannels;

      for (var i = 0; i < numChannels; i++) {
        channels.push(this.buffer.getChannelData(i));
      }

      return channels;
    }
  }]);

  return WebAudioPlayer;
}(EventEmitter);

export default WebAudioPlayer;